import { inferRouteObject } from 'react-router-typed-object';

import { PrivateRoute, Roles, or } from '@/js/libs/use-auth';

import Creatives from 'src/scenes/Creatives';
import { digitalCreativesRouterSearchParamsSchema } from 'src/scenes/Creatives/containers/Digital/schema';
import Status from 'src/scenes/Status';

const index = true;

export const creativesRouteObject = inferRouteObject({
  path: 'creatives',
  element: (
    <PrivateRoute
      roles={or(Roles.SELF_BOOKING, Roles.ADSERVER_CREATIVES, Roles.MANAGE_DIGITAL_CREATIVES, Roles.MANAGE_PRINT_CREATIVES, Roles.ADMIN)}
      noAccessComponent={Status.NotFound}
    />
  ),
  children: [
    {
      Component: Creatives.Helmet,
      children: [
        {
          path: 'digital',
          element: <PrivateRoute roles={or(Roles.SELF_BOOKING, Roles.MANAGE_DIGITAL_CREATIVES)} noAccessComponent={Status.NotFound} />,
          children: [
            {
              Component: Creatives.Digital.Providers,
              children: [
                {
                  path: 'bulk-upload',
                  element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
                  children: [{ index, Component: Creatives.Digital.BulkUploadNative }],
                },
                { index, Component: Creatives.Digital.CreativesList },
              ],
            },
            { path: 'create', Component: Creatives.Digital.CreativeForm },
            { path: ':creativeId/edit', Component: Creatives.Digital.CreativeForm },
          ],
          searchParams: digitalCreativesRouterSearchParamsSchema.parse,
        },
        {
          path: 'print',
          element: <PrivateRoute roles={Roles.MANAGE_PRINT_CREATIVES} noAccessComponent={Status.NotFound} />,
          children: [
            { index, Component: Creatives.Print.CreativesList },
            { path: 'create', Component: Creatives.Print.CreativeForm },
            { path: ':creativeId', Component: Creatives.Print.CreativeForm },
          ],
        },
        {
          path: 'ad-server',
          element: <PrivateRoute roles={Roles.ADSERVER_CREATIVES} noAccessComponent={Status.NotFound} />,
          children: [
            { index, Component: Creatives.AdServer.CreativesList },
            { path: ':creativeId', Component: Creatives.AdServer.CreativeDetails },
          ],
        },
        {
          path: 'templates',
          element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
          children: [
            { index, Component: Creatives.Templates.TemplatesList },
            { path: 'create', Component: Creatives.Templates.TemplateForm },
            { path: ':templateId/edit', Component: Creatives.Templates.TemplateForm },
          ],
        },
        {
          index,
          Component: Creatives.RoleBasedRedirector,
        },
      ],
    },
  ],
});
